import * as types from "../types";

const initialState = {
  loading: false,
  app: null,
  requestDevice: null,
  error: null,
};

export default function fetchAppReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_APP_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.FETCH_APP_SUCCESS:
      return {
        ...state,
        loading: false,
        app: action.payload.app,
      };

    case types.FETCH_APP_FAILURE:
      return {
        ...state,
        loading: false,
        app: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
